const getESignerContactValues = (entityInfo) => {
  // identify phone and email values from obj
  let emails = Object.keys(entityInfo).filter(data => data.toLowerCase().includes('email') && entityInfo[data]);
  let phones = Object.keys(entityInfo).filter(data => data.toLowerCase().includes('phone') && entityInfo[data]);

  // set values
  emails = emails.map(data => entityInfo[data]);
  phones = phones.map(data => entityInfo[data]);

  return {
    emails: emails || [],
    phones: phones || []
  }
}

// default to first phone/email if there aren't multiples
const setPhoneAndEmail = (emailList, phoneList) => {
  let phoneVal, emailVal = null;

  if (emailList.length === 1) {
    const obj = emailList.at(0);
    emailVal = obj && obj.value;
  }

  if (phoneList.length === 1) {
    const obj = phoneList.at(0);
    phoneVal = obj && obj.value;
  }

  return {
    phoneVal,
    emailVal
  }
}

// a phone or email is required for esign
const isMissingPhoneOrEmail = (emailList, phoneList) => {
  if (emailList < 1 || phoneList < 1)
    return true;

  if (emailList.filter(x => x.value !== undefined) < 1 || (phoneList.filter(x => x.value !== undefined) < 1))
    return true;

  if (emailList.filter(x => x.value !== '') < 1 || (phoneList.filter(x => x.value !== '') < 1))
    return true;

  return false;
}


const getEsignPrefillData = (role, fullFormState, index = 0) => {
  if (role) {
    let filteredData = fullFormState.pages.esign.esigner.filter(x => x.role === role);
    if (filteredData && filteredData.length > index) {
      return { prefillPhone: filteredData[index].phone, prefillEmail: filteredData[index].email, prefillAuthentication: filteredData[index].authentication };
    }else{
      return { prefillPhone: null, prefillEmail: null, prefillAuthentication: null };
    }
  }
}

export {getESignerContactValues, setPhoneAndEmail, isMissingPhoneOrEmail , getEsignPrefillData}


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/Helpers/ESigner/eSignerFunctions.js